import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import ApiKeysList from './ApiKeysList';
import CreateButton from 'components/button/CreateButton';
import Header from 'components/ui/general/Header';
import Title from 'components/ui/general/Title';
import authHelper from 'helpers/auth';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';
import translate from 'components/hoc/translate';

const ApiKeysListContainer = (props) => {
    const {
        resource,
        translate,
    } = props;

    const initialFilters = {
        enabled: {
            matchType: filterMatchTypes.equals,
            value: '1',
        },
    };

    const isImpersonated = authHelper.isImpersonated();

    return (
        <div>
            <Header>
                <Title title={ translate('resources.api-keys.title') } />

                <Actions>
                    { !isImpersonated &&
                        <CreateButton basePath={ resource } />
                    }
                </Actions>
            </Header>

            <ApiKeysList
                { ...props }
                initialFilters={ initialFilters }
            />
        </div>
    );
};

ApiKeysListContainer.propTypes = {
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(ApiKeysListContainer);



// WEBPACK FOOTER //
// ./src/pages/api-keys/list/ApiKeysListContainer.js